var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Business Accounts"}},[_c('List',{staticClass:"mb-3",attrs:{"accounts":_vm.accounts,"bizs":_vm.bizs}}),_c('Summary',{attrs:{"accounts":_vm.accounts}}),_c('Touch'),_c('Credits'),_c('WaitlistMonthly'),_c('CreateCredit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }